import styled from 'styled-components';

export const FeedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const CardPost = styled.div`
  background: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  width: 100%;

  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div`
  display: flex;
  gap: 1rem;
  padding: 10px 17px;
  display: flex;
  align-items: center;

  > h3 {
    font: normal normal 600 20px/0px 'Source Sans Pro';
    color: #4a494a;
  }
`;

export const CardLogo = styled.img`
  width: 45px;
  height: 45px;
  border-radius: 50%;
`;

export const CardImage = styled.img`
  width: 100%;
`;

export const CardActionButton = styled.button`
  max-width: 200px;
  height: 30px;
  margin-top: 1rem;
  margin-right: 1rem;
  padding: 0 1rem;
  box-shadow: 0px 2px 3px #00000029;
  border-radius: 10px;
  background: #6d3195;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-size: 15px;
`;

export const CardContent = styled.div`
  padding: 1.5rem 1rem;

  > h3 {
    font: normal normal 600 20px/18px Source Sans Pro;
    width: 100%;
    color: #4a494a;
  }

  > span {
    font: normal normal normal 15px/14px Source Sans Pro;
    color: #9b9a9b;
  }
`;

export const Description = styled.h4`
  font: normal normal normal 18px/18px Source Sans Pro;
  color: #141212;
  white-space: pre-line;
`;
